import React from "react"
//import Rating from "react-rating" // https://www.npmjs.com/package/react-rating
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faCalendar, faChevronLeft, faMapMarkerAlt, faMedal } from "@fortawesome/free-solid-svg-icons";
import 'react-responsive-modal/styles.css';
import Cookies from 'universal-cookie';
import moment from "moment";
import BaggageIcons from '../../features/Baggage';
import configData from '../../config/config.json';

//import Deal from "./Deal"

//var lastObj = null;
const API_ENDPOINT = configData.API_ENDPOINT;

class CardLine extends React.PureComponent {

    constructor (props) {
        super(props);

        this.state = {
            'active' : false,
            //'open': false,
			//'open_covid19': false,
            'data': this.props.data,
            'property_photo': null,
        }



        this.handleClick = this.handleClick.bind(this); 
        this.handleMoreDetailsBtn = this.handleMoreDetailsBtn.bind(this); 

       
    }

    
    componentDidMount() {
       // initGA();
    }

 

    onCloseModal = () => {
        //this.setState((prevState) => ({ 'open': false, 'active': prevState.active}));
        //this.setState({open: false, open_covid19: false})
      };

    render() {
      //  if (this.props.data.hotels == null ) return (<div>NO HOTELS {this.state.to_agoda_city_id}</div>)

        //const { open, open_covid19 } = this.state;
        //console.log(this.props.data)
       
        //const deal_price = Math.ceil(this.props.data.deal_price);
        //const departure_date = formatDate(this.props.data.flight.outbound.departure_date);
        //const return_date = formatDate(this.props.data.flight.inbound.arrival_date);
        const departure_date = formatDate(this.props.data.departure.date);
        const return_date = formatDate(this.props.data.return.date);
        const timeDiff = Math.abs(new Date(this.props.data.return.date).getTime() - new Date(this.props.data.departure.date).getTime());
        const nights =  Math.ceil(timeDiff / (1000 * 3600 * 24)); 

        const item_uri = "/deal/" + this.props.data.uid;
        const weekendClass = (this.props.data.weekend_il)?'show':'hide';
        //const holidayClass = (this.props.data.holidays.length>0)?'show':'hide';

    
//      console.log(this.props.data.hotels[0].deal_price)
        let duration_departure, duration_return, out_departure_time,out_arrival_time,in_departure_time,in_arrival_time,to_airline, return_airline=null;

                out_arrival_time = this.getFlightTime(this.props.data.flight.outbound.arrival_date);
                out_departure_time = this.getFlightTime(this.props.data.flight.outbound.departure_date);
                duration_departure = this.getTextualDuration(this.props.data.flight.outbound.duration);
                to_airline = this.props.data.flight.outbound.airline.code;
                //let to_airline_icon = this.props.data.flight.outbound.airline.icon;

                in_departure_time = this.getFlightTime(this.props.data.flight.inbound.departure_date);
                in_arrival_time = this.getFlightTime(this.props.data.flight.inbound.arrival_date);
                duration_return = this.getTextualDuration(this.props.data.flight.inbound.duration);
                return_airline = this.props.data.flight.inbound.airline.code;
                //let return_airline_icon = this.props.data.flight.inbound.airline.icon;
        
        const adults = this.props.data.pax?.adults>0?this.props.data.pax?.adults*1:2;
        const children = this.props.data.pax?.children>0?this.props.data.pax?.children*1:0;
        const infants = this.props.data.pax?.infants>0?this.props.data.pax?.infants*1:0;
        const passengers_count = adults + children + infants;
        let pax_caption = '';

        switch(adults) {
            case 1: pax_caption = 'למבוגר';break;
            case 2: pax_caption = 'לאדם בהרכב זוגי';break;
            default: pax_caption = `לאדם בהרכב ${adults} מבוגרים`;break;
        }

        if (children > 0) {

            if (adults == 1)
                pax_caption = 'לאדם בהרכב של מבוגר'
            if (adults == 2)
                pax_caption = 'לאדם בהרכב של זוג'

            // add the children count
            if ( this.props.data.pax?.children < 2)
                pax_caption += '+ילד';
            else
                pax_caption += '+' + this.props.data.pax?.children + ' ילדים';

        }

        return (           
            <div title={this.props.data.uid} href={item_uri} airport={this.props?.airport} airline={this.props?.airline} style={{order: Math.ceil(this.props.data.price/passengers_count)}}  className={"lineWrapper " +  (this.state.active?'active':'')} id={ this.props.data.uid + "-line-" + this.props.counter  }>
                <div onClick={(e)=>this.handleClick(e)}>
                
                {/*}
                    <div className={"line line-"+ (this.props.counter+1) + " " + (this.props?.expired===true?' expired ':'') + " " + (( (this.props.total >= 3 && this.props.counter<2) || (this.props.total<3 && this.props.counter<this.props.total-1) ) && this.props.member==="0" ?'unlocked':'unlocked')}>
                        <span className="overlay lock_trigger"></span>
                        <div className="dates">
                            <p className="range">{return_date} - {departure_date}</p>
                            <div className="symbols">
                                <span className="days">{this.getDays( this.props.data.departure.dow, this.props.data.return.dow)}</span>
                                <span className={"weekend " + weekendClass}>סופ"ש</span>
                                {
                                    // Show holidays
                                    this?.props?.data?.holidays?.map((item, index) => {
                                            return (<span className="holiday" key={'holiday'+index}>{item}</span>)
                                    })
                                }{
                                    // Show vacations
                                    
                                }
                                <span className="special-icon black-friday"><img src="/images/icons/black-friday.png"></img></span>
                            </div>
                            {
                                this.props.data.ancillaries.length>0?
                                    this.props.data.ancillaries.map((item, index) => {
                                        if (item?.code=='cancellation_protection_included' && item?.included==true) {
                                            return (
                                                <p className="captionHighlight" key={'flex'+index}>
                                                    <div style={{inline:`block`}} className="icon"><FontAwesomeIcon icon={faShieldAlt} /></div>
                                                    <div className="text">מגן ביטול חופשה כלול במחיר</div>
                                                </p>
                                            );
                                        } 
                                    }): 
                                    <p className="caption"><span>מחיר לכל התקופה</span>{pax_caption}</p>
                            }
                                
                        </div>
                        <div className="price">
                            <p className="amount"><span className="from">מ-</span>{this.getCurrencySymbol( this.props.data.currency )}{Math.ceil(this.props.data.price/passengers_count)}</p>
                            <p className="amountCaption">לנוסע</p>
                            <p className="nights">
                                <span className="note">טיסה + מלון</span>
                                <span className="count">{nights} לילות</span>
                            </p>
                        </div>
                        <div className={'expired' + (this.props?.expired!==true?' hidden ':'')}>אזל המלאי</div>
                        <div className="members_lock">
                            <p className="caption lock_trigger">מחיר סודי לחברי VIP</p>
                            <p className="btn">
                                <button className="lock_trigger">הרשמו חינם</button>
                            </p>
                        </div>
                    </div>
    */}
                    <div style={{padding:'.5em .75em 0 0'}} className={"line line-"+ (this.props.counter+1) + " " + (( (this.props.total >= 3 && this.props.counter<2) || (this.props.total<3 && this.props.counter<this.props.total-1) ) && this.props.member==="0" ?'unlocked':'unlocked')}>
                        <span className="overlay lock_trigger"></span>
                        <div className="dates" style={{fontSize:'1em', margin:`0`, lineHeight:0}}>
                            <h4 style={{fontWeight:800, color:'#333',fontSize:'1.1em'}}>טיסה + מלון</h4>
                            <div className="symbols"  style={{fontSize:'1em', color:'#888'}}>
                                <div style={{fontWeight:'600', color: '#555', fontSize:'.9em'}}>
                                    <FontAwesomeIcon icon={faMoon} style={{display:'inline-block', margin:'0 0 0 0.3em', fontSize:'0.8em'}} /> 
                                    <span style={{ fontWeight:700}}>{nights} לילות </span>
                                    <span style={{color:'#777'}}>({this.getDays( this.props.data.departure.dow, this.props.data.return.dow)})</span>
                                </div>
                            </div>
                            <p className="range" style={{color:'#555',fontSize: '.9em', fontWeight:'600'}}>
                                <FontAwesomeIcon icon={faCalendar} style={{display:'inline-block', margin:'0 0 0 0.3em', fontSize:'0.9em',}} />
                                {return_date} - {departure_date}</p>
                        </div>
                        
                        <div className="price" style={{fontSize:'2em', display:'flex',flexDirection:'column',justifyContent:'center', padding:0, margin:0}}>
                            <p className="amount" style={{color: '#124b71', fontWeight: 700}}><span className="from">מ-</span>{this.getCurrencySymbol( this.props.data.currency )}{Math.ceil(this.props.data.price/passengers_count)}</p>
                            <p className="amountCaption" style={{fontSize:'0.35em', borderBottom:'none',paddingBottom:0}}>לאדם בהרכב זוגי</p>
                        </div>
                        <div className="more" style={{padding:'0 .25em 0 .25em',display:'flex',flexDirection:'column',justifyContent:'center'}} >
                            <p><FontAwesomeIcon icon={faChevronLeft} style={{ margin:'0 0 0 .5em'}}  /> </p>
                        </div>
                        <div className="members_lock">
                            <p className="caption lock_trigger">מחיר סודי לחברי VIP</p>
                            <p className="btn">
                                <button className="lock_trigger">הרשמו חינם</button>
                            </p>
                        </div>
                    </div>
                    <div style={{height:'1.9em', display:'flex'}}>
                        <span className={"weekend " + weekendClass} style={{maxHeight:'2em'}}>סוף שבוע</span>
                        {
                            // Show holidays
                            this?.props?.data?.holidays?.map((item, index) => {
                                    return (<span style={{maxHeight:'2em'}} className="holiday" key={'holiday'+index}>{item}</span>)
                            })
                        }{
                            // Show vacations
                            
                        }
                        <span className="special-icon black-friday"><img src="/images/icons/black-friday.png"></img></span>
                    </div>

                </div>
                <div className={"dealDetails " + (this.state.active?'active':'')} id={this.props.data.flight_uid} >            
                    
                    <div className="card flight" style={{margin:"0"}}>
                        <div className="title sideTab">טיסה</div>
                        <div className="deal_content">
                            <div className="route" onClick={(e)=>this.handleMoreDetailsBtn(e, '/deal/' + this.props.data.uid, 'more-details', this.props.data.uid)}> 
                                <div className="airline"><img src={to_airline!=null?'/images/airlines/32/'+to_airline+'.png':''} alt={to_airline} className={"airline "+(to_airline==null?'hide':'')} /></div>
                                <div className="from"><div className="time">{out_departure_time}</div>{this.state?.data?.flight?.outbound?.departure_iata_name} </div>
                                <div className="duration"><p className="duration_caption">{duration_departure}</p><p className="duration_comment">טיסה ישירה</p></div>
                                <div className="to"><div className="time">{out_arrival_time}</div>{this.state?.data?.flight?.outbound?.arrival_iata_name}</div>
                            </div>

                            <div className="route"  onClick={(e)=>this.handleMoreDetailsBtn(e, '/deal/' + this.props.data.uid, 'more-details', this.props.data.uid)}>
                                <div className="airline"><img src={return_airline!=null?'/images/airlines/32/'+return_airline+'.png':''} alt={return_airline} className={"airline "+(return_airline==null?'hide':'')} /></div>
                                <div className="from"><div className="time">{in_departure_time}</div>{this.state?.data?.flight?.inbound?.departure_iata_name} </div>
                                <div className="duration"><p className="duration_caption">{duration_return}</p><p className="duration_comment">טיסה ישירה</p></div>
                                <div className="to"><div className="time">{in_arrival_time}</div>{this.state?.data?.flight?.inbound?.arrival_iata_name}</div>
                            </div>

                        </div>

                            
                    </div>
                   
        
                    <div className="card hotel" style={{margin:"0"}} onClick={(e)=>this.handleMoreDetailsBtn(e, '/deal/' + this.props.data.uid, 'more-details', this.props.data.uid)}>
                        <div className="title sideTab">לינה</div>
                        <div className="hotel_content">
                            <div className="hotel_title" style={{maxWidth:'220px'}}>{this.props.data.property.name.substring(0,160) + " "}</div>
                            <div className="hotel_image"  style={{backgroundImage: "url(" + (this.props.data.property.photos?`https://cdn.cookiecrumbz.com/images/properties/400/${this.props.data.property.photos[0]}`:'') + ")"}}></div>
                            <div className="hotel_details">
                                <div className="div_stars"> <div className="stars">{this.getStarsImage(this.props.data.property.stars)}</div>
                                <div className={'div_breakfast ' + (this.GetMealPlanName(this.props.data.property.meal_code)!=''?'':'hide')}>{this.GetMealPlanName(this.props.data.property.meal_code)} <i className="fa fa-coffee xl"></i></div>
                                {/*<Rating 
                                        emptySymbol="fa fa-star"
                                        fullSymbol="fa fa-star-o"
                                        stop={this.props.data.property_stars} 
                                        readonly/> 
                                */}
                                </div>
                                <div className="div_ratin hide"> <div className="rating">{this.props.data.property.rating}</div> דירוג אורחים</div>
                                <div className={'div_wifi ' + (this.props.data.property.free_wifi===1?'':'hide')}>אינטרנט חינם <i className="fa fa-wifi xl"></i></div>
                                
                                <div className={'div_center'}>קרוב למרכז העיר <span className="icon" title={`created: ${this.props.data?.created} updated: ${this.props.data?.updated}`}> <FontAwesomeIcon icon={faMapMarkerAlt} /></span></div>
                                <div className={'div_center'}>מלון מבוקש <span className="icon"> <FontAwesomeIcon icon={faMedal} /></span></div>
                            </div>
                        </div>
                    </div>

                    <BaggageIcons baggage={this.props?.baggage} ></BaggageIcons>
                </div>

                <div className={"order " +  (this.state.active?'active':'')}>
                    <a href={item_uri}><button onClick={(e)=>this.handleMoreDetailsBtn(e, item_uri, 'more-details', this.props.data.uid)}>פרטים נוספים <i className="fa fa-angle-double-left xl"></i></button></a>
                </div>
            </div>
        )
    }

    isFriend = async(event, url, source, deal_id) => {
        window.location = url
    }

    
    /**
     * Calculate the number of days / weeks / months between the departure date & today
     * @param {*} departure_date 
     */
    GetTimeToDeparture(departure_date) {
        try {
            const today = new Date();
            const [datestr, timestr] = (departure_date+'').split("T");
            const [year, month, day] = datestr.split("-");
            const departureDate = new Date(+year, +month - 1, +day);

            const difference = departureDate.getTime() - today.getTime();

            const daysToDeparture = Math.ceil(difference / (1000 * 60 * 60 * 24));
            
            switch (true) {
                case daysToDeparture <= 2: return '1-2 days';break;
                case daysToDeparture <= 4: return '3-4 days';break;
                case daysToDeparture <= 7: return '5-7 days';break;
                case daysToDeparture <= 10: return '8-10 days';break;
                case daysToDeparture <= 13: return '11-13 days';break;
                case daysToDeparture <= 21: return '2 weeks';break;
                case daysToDeparture <= 28: return '3 weeks';break;
                case daysToDeparture <= 35: return '4 weeks';break;
                case daysToDeparture <= 42: return '5 weeks';break;
                case daysToDeparture <= 49: return '6 weeks';break;
                case daysToDeparture <= 56: return '7 weeks';break;
                case daysToDeparture <= 63: return '8 weeks';break;
                case daysToDeparture <= 70: return '9 weeks';break;
                case daysToDeparture <= 100: return '2 months';break;
                case daysToDeparture <= 130: return '3 months';break;
                case daysToDeparture <= 160: return '4 months';break;
                case daysToDeparture <= 190: return '5 months';break;
                case daysToDeparture <= 220: return '6 months';break;
                case daysToDeparture <= 250: return '7 months';break;
                case daysToDeparture <= 280: return '8 months';break;
                case daysToDeparture <= 310: return '9 months';break;
                case daysToDeparture > 310: return '10+ months';break;
                default: return '';
            }
        } catch(e) {
            return 'ERROR'
        }
    }
    
    GetMealPlanCode(code) {
        let local_meal_plan_code='RO';
        
        switch(code) {
            case 'SA'||'SP'||'SC': local_meal_plan_code='RO';break; // Accommodation only
            case 'HD': local_meal_plan_code='BB';break;             // B&B 
            case 'HM'||'MB'||'MP': local_meal_plan_code='HB';break; // HAlf Board
            case 'PC'||'PV': local_meal_plan_code='FB';break;       // Full board
            case 'TI'||'TP': local_meal_plan_code='AI';break;       // All Inclusive
            default: local_meal_plan_code='RO'
        }

        return local_meal_plan_code;
    }

    GetMealPlanName = (code) => {
        switch(code) {
          case 'HM': return 'חצי פנסיון'; // Breakfast and half board
          case 'MB': return 'חצי פנסיון + משקאות'; //Half board with drinks
          case 'MP': return 'חצי פנסיון'; //Half board
          case 'PC': return 'פנסיון מלא'; //Full board
          case 'PV': return 'פנסיון מלא + משקאות'; //Full board with drinks
          case 'SA': return ''; //Accommodation only
          case 'SP': return ''; //According to programme
          case 'TI': return 'הכל כלול'; //All inclusive
          case 'TP': return 'הכל כלול פרימיום'; //All inclusive premium
          case 'SC': return ''; //Self Catering
          case 'HD': return 'ארוחת בוקר כלולה'; //Bed and breakfast
        }
    };

      
    getStarsImage(num) {
        let output = "";

        for (let i=0;i<num;i++) {
            output+="★";
        }

        return output;
    }

    getDays(day1, day2=-1) {
    
        let days = "";
        switch(day1) {
            case 0: days="ראשון"; break;
            case 1: days="שני"; break;
            case 2: days="שלישי"; break;
            case 3: days="רביעי";break;
            case 4: days="חמישי"; break;
            case 5: days="שישי"; break;
            case 6: days="שבת"; break;
            default: break;
        }
    
        if (day2>=0) {
            days += " - ";
        
            switch(day2) {
                case 0: days+="ראשון"; break;
                case 1: days+="שני"; break;
                case 2: days+="שלישי"; break;
                case 3: days+="רביעי";break;
                case 4: days+="חמישי"; break;
                case 5: days+="שישי"; break;
                case 6: days+="שבת"; break;
                default: break;
            }
        }
        
        return days;
    }

    /*getStarsImage(num) {
        switch(num*1) {
            case 1: return '&#xf006;';
            case 2: return '&#xf006;&#xf006;';
            case 3: return '&#xf006;&#xf006;&#xf006;';
            case 4: return '&#xf006;&#xf006;&#xf006;&#xf006;';
            case 5: return '&#xf006;&#xf006;&#xf006;&#xf006;&#xf006;';
            default: return '';
        }
    }*/

    getCurrencySymbol(cur) {
        let currency_symbol;

        switch( cur ) {
            case 'USD': currency_symbol = '$';break;
            case 'EUR': currency_symbol = 'EURO';break;
            case 'ILS': currency_symbol = 'NIS';break;
            default: currency_symbol = '$';
        }

        return currency_symbol;
    }

    lameLogin(uid, pw) {
        const { createHash } = require('crypto');
        const hashedPw = createHash('sha256').update(pw).digest('hex');
        if (hashedPw=='432164f22b5c124cd4971bee34cbd3e4a1c392ee46f4ed5382359ca55f53ed4a' || hashedPw=='879744f88f74c555a26252f1bba694a6d890d4bd844b9a7f7f85e12b8004dbef') {
            const cookies = new Cookies();
            cookies.set('logged',1)
            window.location= '/deal/' + this.props.data.uid;
        }
    }

    
    handleClick(event) {
        
        if (this.props?.expired===true) return
        
        // show filters 
        //document.getElementsByClassName('filters_toggle')[0].className='filters_toggle float visible'
        //document.getElementsByClassName('filters').className='filters visible'

        event.stopPropagation()
        
        console.log(event.target.className)

        if (event.target.className.indexOf("lock_trigger")>=0) {
            //Event("DEALS", "Member Signup Button", this.props.data.deal_id);    
            window.location = "members/signup";
            return;
        }
        
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });  
        window.dataLayer.push({
            event: 'PreviewDeal',
            page: 'homepage',
            'pageTitle' : window.title,
            pageUrl: '/',
            uid: this.props.data.uid,
            departure: this.props.data.departure.date,
            destination: this.props.data.destination?.city?.name + ' ' + this.props.data.destination?.city?.id,
            stars: this.props.data.property.stars,
            weekend: this.props.data.weekend_il,
            holidays: this.props.data.holidays,
            vacations: this.props.data.vacations,
            nights: this.props.data.nights,
            value: this.props?.data?.price,
            currency: this.props.data.currency,
            ecommerce: {
                currencyCode: this.props.data.currency,
                detail: {
                    actionField: {
                        list_name: 'homepage-results',
                    },
                    products: [{
                        id: this.props.data.uid,
                        name: this.props.data?.code,
                        category: this.props?.country_name+'/'+this.props.city_name,
                        price: this.props?.data?.price,
                        brand: 'afnu',
                        //list_name: 'destination-results',
                        //list_position: this.props.counter
    
                    }]
                }
            }
        });

       

        //Event("DEALS", "Preview Deal", this.props.data.deal_id);
        const API_QUERY = "?";//"get/?lang=he";
        let API_PREDEFINED_QUERY = this.props.uid;
        let API_OBJECT = `/search/packages/${this.props.data.uid}`;
       
        

        // Load the property details (only once)
        if (!this.state.active && this.state.property_photo==null) {
            console.log('Fetching deal details')

            // Fetch deal details
            this.setState(prevState=> ({
                active: !prevState.active
            }));
            fetch(API_ENDPOINT + API_OBJECT)
            .then(response => {
                if (response.ok) {
                    return response.json()
                } else {
                    throw new Error('Sorry, we couldn\'t get response from the remote server, please try again in few seconds (Error 303)');
                }
                }).then(data=>{

                    let defaultPhoto = data.property?.photos[0]?.url;
                    const selectedPhoto = data.property?.photos.find(photo=>photo?.priority==10);
                    if (selectedPhoto && selectedPhoto!='') 
                        defaultPhoto = selectedPhoto;

                    this.setState(prevState=> ({
                        active: true,
                        data: data,
                        property_photo: defaultPhoto,
                        destination_name_en: data.property?.city_name
                    }),()=>{
                        // After fetched property detils sent event to GTM
                        window.dataLayer.push({
                            event: "select_item",
                            ecommerce: {
                              item_list_id: 'deals',
                              item_list_name: 'Deals',
                              currency: this.props?.data?.currency,
                              value: this.props?.data?.price,
                              items: [
                                {
                                    item_id: this.props.data.uid,
                                    item_name: this.props.data?.code,
                                    index: 0,
                                    item_brand: data.property?.city_name,//this.props.city_name,
                                    item_category:  "adults:2,children:0,infants:0,rooms:1",
                                    item_category2: "stars: " + this.props.data.property?.stars + " meals: " +  this.GetMealPlanCode(this.props.data.property.meal_code),
                                    item_category3: "nights: " + this.props.data?.nights,
                                    item_category4: "departure: " +  this.GetTimeToDeparture(this.props.data.departure?.date),
                                    item_category5: "month: "+ this.props.data.departure?.date.split("-", 2).join("-"), // remove everything after second dash occurance (which converts the date from 2023-07-29T00:00:00.000Z to 2023-07)
                                    item_list_id:   "deals",
                                    item_list_name: "Deals",
                                    item_variant:   "standard",
                                    location_id: this.props.data.destination.city.id,
                                    price: this.props?.data?.price,
                                    quantity: 1
                              }
                              ]
                            }
                          });
                    });
                    
            
                }
                ).catch(error=>{
                    throw new Error('Sorry, we couldn\'t get response from the remote server, please try again in few seconds (Error 303)');
                });

        } else {
            this.setState(prevState=> ({
                active: !prevState.active
            }));
        }
       

    


        /*if (lastObj != null && lastObj!=myid && document.getElementById(lastObj)!=null) {
            document.getElementById(lastObj).style.display='none';
            document.getElementById("button" + lastObj).style.display='none';
        }

        if (document.getElementById(myid)!=null) {
            if (document.getElementById(myid).style.display==='none') {
                document.getElementById(myid).style.display='block';
                document.getElementById("button" + myid).style.display='block';
            }
            else {
            document.getElementById(myid).style.display='none';
            document.getElementById("button" + myid).style.display='none';
            }
        }
        lastObj = myid;
        */
    }

    handleMoreDetailsBtn(event, url, source, deal_id) {
        const cookies = new Cookies();
        //if (cookies.get('logged')!=1) {
		//    this.setState({ open_covid19: true });
            //Event("DEALS", source + " button clicked", deal_id)
        //} else {
        //
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });  
        window.dataLayer.push({
            event: 'OpenDealDetailsPage',
            pageUrl: '/',
            uid: this.props.data.uid,
            departure: this.props.data.departure.date,
            destination: this.props.data.destination?.city?.name + ' ' + this.props.data.destination?.city?.id,
            stars: this.props.data.property.stars,
            weekend: this.props.data.weekend_il,
            holidays: this.props.data.holidays,
            vacations: this.props.data.vacations,
            nights: this.props.data.nights,
            value: this.props?.data?.price,
            currency: this.props.data.currency,
            ecommerce: {
                currencyCode: this.props.data.currency,
                add: {
                    actionField: {
                        list: 'homepage-deal-preview'
                    },
                    products: [{
                        id: this.props.data.uid,
                        name: this.props.data?.code,
                        category: this.props?.country_name+'/'+this.props.city_name,
                        price: this.props?.data?.price,
                        brand: 'afnu',
                    }]
                }
            }
        });
        
        window.dataLayer.push({
            event: "view_item",
            ecommerce: {
              currency: this.props?.data?.currency,
              value: this.props?.data?.price,
              items: [
              {
                item_id: this.props.data.uid,
                item_name: this.props.data?.code,
                index: 0,
                item_brand: this.state?.destination_name_en, //this.props.city_name,
                item_category:  "adults:2,children:0,infants:0,rooms:1",
                item_category2: "stars: " + this.props.data.property?.stars+" meals: " + this.GetMealPlanCode(this.props.data.property.meal_code),
                item_category3: "nights: " + this.props.data?.nights,
                item_category4: "departure: " + this.GetTimeToDeparture(this.props.data.departure?.date),
                item_category5: "month: "+ this.props.data.departure?.date.split("-", 2).join("-"), // remove everything after second dash occurance (which converts the date from 2023-07-29T00:00:00.000Z to 2023-07),
                //item_list_id: "related_products",
                //item_list_name: "Related Products",
                item_variant: "standard",
                location_id: this.props.data.destination.city.id,
                price: this.props?.data?.price,
                quantity: 1
              }
              ]
            },
            eventCallback: function() {
                window.location = url;
              }
          });

        setTimeout(function() {window.location = url}, 500); 


        //}
    }
    /*
    handleBookingBtn(event) {
        window.open("/deal/" + this.props.data.deal_id);
        window.open(this.props.data.flight_partner_order_url);
        window.open(this.props.data.property_landing_url);
    }
*/
    getTextualDuration(duration) {
        return (duration/60/60+"" ).split('.')[0]+ ' שעות ו-' + Math.round((duration/60/60)%1*60) + " דק'";
    }

    
    getFlightTime(ftime) {
        return  moment.parseZone(ftime).format("HH:mm");

        /*
        console.log(ftime)
        if (!ftime) return;

        //console.log(moment.getTime(ftime))

        //const d = new Date(ftime);
        //const t = ftime.split(/[- :]/);
        const t = ftime.split(/[-T:]/);
        console.log(t)
        // Apply each element to the Date function
        var date_struct = new Date(t[0], t[1]-1, t[2], t[3], t[4], t[5].split('+')[0]);
        //console.log(date_struct)
        var d = new Date(date_struct);
        console.log(date_struct)

        console.log(("0" + d.getHours()).slice(-2) + ":" +  ("0"+d.getMinutes()).slice(-2))

        return ("0" + d.getHours()).slice(-2) + ":" +  ("0"+d.getMinutes()).slice(-2)
        */
    }

    
}

function formatDate(date) {
    const d = new Date(date);

    return ("0" + d.getDate()).slice(-2) + "/" + ("0"+(d.getMonth()+1)).slice(-2) + "/" +
    d.getFullYear();
}


export default CardLine